module.exports = __webpack_public_path__ + "images/screen-shots/google-sheets-sharing-settings-1ebc8f2139d1d4677d877c8be44ef438.png";